import { useRef } from 'react';
import { useGridFilter } from 'ag-grid-react';
import { Form } from 'antd';
import { observer } from 'mobx-react-lite';

import { createFilterComponent } from '../create-data-grid-filter';
import {
  createOneOfFilterModel,
  OneOfFilterModel,
  OneOfFilterParams,
} from './core';
import { OneOfFilterForm } from './one-of-filter.form';

export const OneOfFilterComponent = createFilterComponent<
  OneOfFilterModel,
  OneOfFilterParams
>(
  observer(({ onModelChange, model, filterParams }) => {
    const { filterName, closeWhenChanged, options } = filterParams;
    const shouldClosePopupAfterChange = closeWhenChanged ?? true;
    const hidePopupRef = useRef<(() => void) | undefined>(() => {});
    const hidePopup = () => hidePopupRef.current?.();

    const [form] = Form.useForm();

    useGridFilter({
      // use for disable client-side filtering
      doesFilterPass: () => true,
      afterGuiAttached: (params) => {
        hidePopupRef.current = params?.hidePopup;
      },
    });

    const onSubmit = (value: number) => {
      const model = createOneOfFilterModel({
        value,
        filterName,
      });

      onModelChange(model);

      if (shouldClosePopupAfterChange) hidePopup();
    };

    const onReset = () => {
      form.resetFields();
      onModelChange(null);

      if (shouldClosePopupAfterChange) hidePopup();
    };

    return (
      <OneOfFilterForm
        options={options}
        form={form}
        value={model?.value}
        onSubmit={onSubmit}
        onReset={onReset}
      />
    );
  }),
);
